import { render, staticRenderFns } from "./ItemCarrusel.vue?vue&type=template&id=a45c5342"
import script from "./ItemCarrusel.vue?vue&type=script&lang=js"
export * from "./ItemCarrusel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports